import React from "react";
import { PersonOrgForm } from "common/components/PersonOrgForm";
import { grey } from "@mui/material/colors";
import Heading from "common/components/Heading";

const AddSupplier = () => {
  return (
    <div>
      <div>
        <div>
          <Heading
            variant={"h3"}
            title={"New Vendor"}
            sxProp={{ fontWeight: 800, m: 2, p: 2, color: grey[600] }}
          />
        </div>
        <PersonOrgForm id="" formName="supplier" />
      </div>
    </div>
  );
};

export default AddSupplier;
